// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Usage extends APIResource {
    /**
     * Get usage statistics for a run.
     */
    retrieve(runID, options) {
        return this._client.get(path `/v1/runs/${runID}/usage`, options);
    }
}
//# sourceMappingURL=usage.mjs.map